import React, { useEffect, useState } from 'react';
import { ChevronLeft } from 'lucide-react';

const SlidePageWrapper = ({ isOpen, onClose, title, children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      setTimeout(() => setIsVisible(false), 300);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[60]">
      <div 
        className={`absolute inset-0 bg-black transition-opacity duration-300 ${
          isAnimating ? 'bg-opacity-50' : 'bg-opacity-0'
        }`}
        onClick={onClose}
      />
      
      <div 
        className={`absolute top-0 right-0 h-full w-full bg-white shadow-2xl transform transition-transform duration-300 ease-out ${
          isAnimating ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{ maxWidth: '100%' }}
      >
        <div className="h-full flex flex-col">
          <div className="bg-white border-b border-black/5 p-4 flex items-center gap-3">
            <button
              onClick={onClose}
              className="p-2 bg-canvas hover:bg-black/[0.06] rounded-full transition-colors"
            >
              <ChevronLeft className="w-6 h-6 text-ink" />
            </button>
            <h2 className="text-xl font-bold text-ink flex-1">{title}</h2>
          </div>

          <div className="flex-1 overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlidePageWrapper;
